import { useEffect, useState } from "react";
import GenericSidebar from "./GenericSidebar";

export default function GenericLayout({ children, url }) {
  const [sideMenuArr, setSideMenuArr] = useState([]);

  useEffect(() => {
    const menuObj = localStorage.getItem("menubardata");
    if (!menuObj) return;

    try {
      const parsed = JSON.parse(menuObj);
      const dashboards = parsed?.dashboard || [];

      let matchedDashboard =
        dashboards.find(d => d.URL === url) ||
        dashboards.find(d => d.sideMenu?.some(m => m.URL?.startsWith(url)));

      if (!matchedDashboard) {
        matchedDashboard = dashboards.find(d => d.defaultMenu);
      }

      if (matchedDashboard?.sideMenu) {
        setSideMenuArr(matchedDashboard.sideMenu);
      }
    } catch (error) {
      console.error("Failed to parse menubardata:", error);
    }
  }, [url]);

  return (
    <div className="layout">
      <div className="sidebar">
        <GenericSidebar sideMenuArrProp={sideMenuArr} />
      </div>
      <div className="main">
        {children}
      </div>
    </div>
  );
}